/**
 * 身份的权重
 */
export const VIPWEIGHT = {
  // 免费
  // freeVip: 0,
  // // 初级
  // basicVip: 10,
  // // 高级
  // advancedVip: 30,
  // // 企业用户
  // enterpriseVip: 100,

  // 免费
  freeVip: 1,
  // 初级
  basicVip: 2,
  // 高级
  advancedVip: 3,
  // 企业用户
  enterpriseVip: 4,
};

// export const VipSpaceStorage = {
//   freeVip: 500 * 1024 * 1024, // 500M
//   basicVip: 1000 * 1024 * 1024, // 1G
//   advancedVip: 10 * 1000 * 1024 * 1024, // 10G
//   enterpriseVip: 9999 * 1000 * 1024 * 1024, // 永久
// };

// export const VipCloudStorage = {
//   freeVip: 7, // 7天
//   basicVip: 30, // 30天
//   advancedVip: 60, // 60天
//   enterpriseVip: 99999, // 永久
// };

export const qaFunctionMock = {
  code: 200,
  data: {
    advancedVip: [
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传的视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 3,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量\u0028单位MB\u0029 ',
        functionLimit: 1024000,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 30,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 30,
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
    ],
    basicVip: [
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传的视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 2,
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 30,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 30,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量\u0028单位MB\u0029 ',
        functionLimit: 1024000,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
    ],
    commodity: [
      {
        commodityCode: '1773394942442676224',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4574,
          point: 300,
          sonRightIds: [4574],
        },
        desc: '300积分',
        discount: 1.0,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4574,"sonRightIds":[4574],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RZoy2Jpyp6yU1M","plan":"price_1SUMYDJg0YSXb5HsHZ7lnAPE"}',
        increaseTime: 1763364965233,
        modelCode: '1',
        originalPrice: 4600,
        realPrice: 4600,
        sort: 9919,
        title: 'AI-积分包-46',
      },
      {
        commodityCode: '1773395323461640192',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4495,
          point: 600,
          sonRightIds: [4495],
        },
        desc: '600积分',
        discount: 0.651163,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4495,"sonRightIds":[4495],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RZoy2Jpyp6yU1M","plan":"price_1SUMYeJg0YSXb5HshTqHmoEQ"}',
        increaseTime: 1763364968438,
        modelCode: '1',
        originalPrice: 8600,
        realPrice: 5600,
        sort: 9920,
        title: 'AI积分包-56',
      },
      {
        commodityCode: '1773395577040871424',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 100035,
          point: 1000,
          sonRightIds: [100035],
        },
        desc: '1000积分',
        discount: 1.0,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":100035,"sonRightIds":[100035],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RZoy2Jpyp6yU1M","plan":"price_1SUMZ0Jg0YSXb5HswxLsc2Bg"}',
        increaseTime: 1763364971391,
        modelCode: '1',
        originalPrice: 11800,
        realPrice: 11800,
        sort: 9921,
        title: 'AI积分-118',
      },
      {
        commodityCode: '1773395891659808768',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 100036,
          point: 2000,
          sonRightIds: [100036],
        },
        desc: '2000积分',
        discount: 1.0,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":100036,"sonRightIds":[100036],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RZoy2Jpyp6yU1M","plan":"price_1SUMZ8Jg0YSXb5HspzLz4l89"}',
        increaseTime: 1763364973847,
        modelCode: '1',
        originalPrice: 19800,
        realPrice: 19800,
        sort: 9922,
        title: 'AI积分包-198',
      },
      {
        commodityCode: '1773399205143191552',
        commodityType: 10,
        content: {
          category: 'advancedVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          mainRightId: 100032,
          point: 3600,
          sonRightIds: [100030, 4400, 4401, 4406, 4409, 100032],
        },
        desc: '每月28',
        discount: 0.474577,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":100032,"sonRightIds":[100030,4400,4401,4406,4409,100032],"restrictedPaymentChannels":[],"product":"prod_TRExDh3SzYNWz3","plan":"price_1SUMTeJg0YSXb5HsUuIzmnOD"}',
        increaseTime: 1763364973822,
        modelCode: '1',
        originalPrice: 70800,
        realPrice: 33600,
        sort: 9923,
        title: '高级-年-336',
      },
      {
        commodityCode: '1773398838112231424',
        commodityType: 10,
        content: {
          category: 'basicVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          mainRightId: 100034,
          point: 1200,
          sonRightIds: [100029, 4408, 4405, 4399, 4398, 100034],
        },
        desc: '每月19',
        discount: 0.48718,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":100034,"sonRightIds":[100029,4408,4405,4399,4398,100034],"restrictedPaymentChannels":[],"product":"prod_TRExDh3SzYNWz3","plan":"price_1SUMTeJg0YSXb5HsDH7fCsX0"}',
        increaseTime: 1763364973847,
        modelCode: '1',
        originalPrice: 46800,
        realPrice: 22800,
        sort: 9925,
        title: '初级-年-228',
      },
      {
        commodityCode: '1773392425637978112',
        commodityType: 10,
        content: {
          category: 'advancedVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 2,
          mainRightId: 100031,
          point: 300,
          sonRightIds: [100028, 4401, 4400, 4406, 4409, 100031],
        },
        desc: '专业-月-36',
        discount: 0.61017,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":100031,"sonRightIds":[100028,4401,4400,4406,4409,100031],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TRExDh3SzYNWz3","plan":"price_1SUMTeJg0YSXb5HsOJkr5utn"}',
        increaseTime: 1763364328262,
        modelCode: '1',
        originalPrice: 5900,
        realPrice: 3600,
        sort: 9935,
        title: '专业-月-36',
      },
      {
        commodityCode: '1773391828746575872',
        commodityType: 10,
        content: {
          category: 'basicVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 2,
          mainRightId: 100033,
          point: 100,
          sonRightIds: [100027, 4408, 4398, 4399, 4405, 100033],
        },
        desc: '初级-月-29',
        discount: 0.74359,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":100033,"sonRightIds":[100027,4408,4398,4399,4405,100033],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_TRExDh3SzYNWz3","plan":"price_1SUMTeJg0YSXb5HsG4Sk0s10"}',
        increaseTime: 1763707625434,
        modelCode: '1',
        originalPrice: 3900,
        realPrice: 2900,
        sort: 9937,
        title: '初级-月-29',
      },
      {
        commodityCode: '1700534318952374272',
        commodityType: 10,
        content: {
          category: 'enterpriseVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          label: '',
          mainRightId: 4580,
          sonRightIds: [4410, 4403, 4402, 4580],
        },
        desc: '海外企业占位年包-误删',
        discount: 1.0,
        extend:
          '{"label":"","showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4580,"sonRightIds":[4410,4403,4402,4580],"restrictedPaymentChannels":[]}',
        increaseTime: 1745992587993,
        modelCode: '1',
        originalPrice: 999999,
        realPrice: 999999,
        sort: 9939,
        title: '海外企业占位年包-误删',
      },
      {
        commodityCode: '1679974859393990656',
        commodityType: 10,
        content: {
          category: 'freeVip',
          commodityName: 'cloud_vip_right',
          currency: 'USD',
          durationType: 5,
          label: '1',
          mainRightId: 4386,
          point: 20,
          sonRightIds: [4391, 4396, 4397, 4404, 4407, 4386],
        },
        desc: '免费商品展示海外',
        discount: 0.0,
        extend:
          '{"label":"1","showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4386,"sonRightIds":[4391,4396,4397,4404,4407,4386],"restrictedPaymentChannels":[]}',
        increaseTime: 1745920634039,
        modelCode: '1',
        originalPrice: 0,
        realPrice: 0,
        sort: 9956,
        title: '免费商品展示海外',
      },
    ],
    enterpriseVip: [
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传的视频时长',
        functionLimit: 100000000,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 20,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 4,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 100,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 100,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量\u0028单位MB\u0029 ',
        functionLimit: 1024000,
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
      {
        funcName: 'fVideoFaceMerge',
        funcTitle: '3.0视频换脸',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
    ],
    freeVip: [
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传的视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量\u0028单位MB\u0029 ',
        functionLimit: 1024000,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 1,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 1,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 1,
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
    ],
  },
  message: 'successful',
  success: true,
};

export const masterFunctionMock = {
  code: 200,
  data: {
    advancedVip: [
      {
        funcName: 'subtitleTranslate',
        funcTitle: '字幕翻译',
      },
      {
        funcName: 'audioTranslate',
        funcTitle: '旁白翻译',
      },
      {
        funcName: 'digitalHumanVideo',
        funcTitle: '数字人视频',
      },
      {
        funcName: 'textEdit',
        funcTitle: '字体编辑',
      },
      {
        funcName: 'videoFaceMerge',
        funcTitle: '视频换脸',
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'exportResolution',
        funcTitle: '导出视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 3,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 30,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 30,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'subtitleRemove',
        funcTitle: '字幕擦除',
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量（单位M）',
        functionLimit: 1024000,
      },
      {
        funcName: 'voiceChanging',
        funcTitle: 'AI变声',
      },
      {
        funcName: 'textToSpeech',
        funcTitle: '文本生成TTS',
      },
      {
        funcName: 'embeddedWorkflow',
        funcTitle: '预制工作流',
      },
      {
        funcName: 'customWorkflow',
        funcTitle: '自定义工作流',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
    ],
    basicVip: [],
    commodity: [
      {
        commodityCode: '1776677479306809344',
        commodityType: 10,
        content: {
          category: 'basicVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 2,
          mainRightId: 4644,
          point: 100,
          sonRightIds: [4652, 4407, 4397, 4398, 4404, 4644],
        },
        desc: '初级-月-29',
        discount: 0.74359,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4644,"sonRightIds":[4652,4407,4397,4398,4404,4644],"restrictedPaymentChannels":[],"product":"prod_RUXfAAMBmb7bZW","plan":"price_1SXbbnJg0YSXb5HsHarLVLxa"}',
        increaseTime: 1764146646124,
        modelCode: '1',
        originalPrice: 3900,
        realPrice: 2900,
        sort: 9879,
        title: '初级-月-29',
      },
      {
        commodityCode: '1776676837943197696',
        commodityType: 10,
        content: {
          category: 'basicVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4643,
          point: 1200,
          sonRightIds: [4650, 4398, 4397, 4404, 4407, 4643],
        },
        desc: '每月19',
        discount: 0.48718,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4643,"sonRightIds":[4650,4398,4397,4404,4407,4643],"restrictedPaymentChannels":[],"product":"prod_RUXfAAMBmb7bZW","plan":"price_1SXbc4Jg0YSXb5HsiFruIQhL"}',
        increaseTime: 1764146646353,
        modelCode: '1',
        originalPrice: 46800,
        realPrice: 22800,
        sort: 9881,
        title: '初级-年-228',
      },
      {
        commodityCode: '1776676145526521856',
        commodityType: 10,
        content: {
          category: 'advancedVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 2,
          mainRightId: 4646,
          point: 300,
          sonRightIds: [4651, 4405, 4399, 4400, 4408, 4646],
        },
        desc: '专业-月-36',
        discount: 0.61017,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4646,"sonRightIds":[4651,4405,4399,4400,4408,4646],"restrictedPaymentChannels":[],"product":"prod_RUXhqmlfi0fBwO","plan":"price_1SXbdFJg0YSXb5HsJUptWduK"}',
        increaseTime: 1764146646651,
        modelCode: '1',
        originalPrice: 5900,
        realPrice: 3600,
        sort: 9883,
        title: '专业-月-36',
      },
      {
        commodityCode: '1776675348608761856',
        commodityType: 10,
        content: {
          category: 'advancedVip',
          commodityName: 'vip_subscription',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4646,
          point: 3600,
          sonRightIds: [4649, 4405, 4408, 4399, 4400, 4646],
        },
        desc: '每月28',
        discount: 0.474577,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4646,"sonRightIds":[4649,4405,4408,4399,4400,4646],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RUXhqmlfi0fBwO","plan":"price_1SXbdNJg0YSXb5HslF80G5fb"}',
        increaseTime: 1764146646204,
        modelCode: '1',
        originalPrice: 70800,
        realPrice: 33600,
        sort: 9885,
        title: '专业-年-336',
      },
      {
        commodityCode: '1776669908948795392',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4591,
          point: 300,
          sonRightIds: [4591],
        },
        desc: '300积分',
        discount: 1.0,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4591,"sonRightIds":[4591],"restrictedPaymentChannels":[],"product":"prod_RXcftEi6BIxozY","plan":"price_1SXbdsJg0YSXb5HsQncK8WPE"}',
        increaseTime: 1764146646125,
        modelCode: '1',
        originalPrice: 4600,
        realPrice: 4600,
        sort: 9887,
        title: 'AI-积分包-46',
      },
      {
        commodityCode: '1776670999740469248',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4653,
          point: 600,
          sonRightIds: [4653],
        },
        desc: '600积分',
        discount: 0.651163,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4653,"sonRightIds":[4653],"restrictedPaymentChannels":[],"modelCode":"1","product":"prod_RXcftEi6BIxozY","plan":"rice_1SXbe2Jg0YSXb5HsiYaLieUS"}',
        increaseTime: 1764146646168,
        modelCode: '1',
        originalPrice: 8600,
        realPrice: 5600,
        sort: 9888,
        title: 'AI积分包-56',
      },
      {
        commodityCode: '1776671690890465280',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4648,
          point: 1000,
          sonRightIds: [4648],
        },
        desc: '1000积分',
        discount: 1.0,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4648,"sonRightIds":[4648],"restrictedPaymentChannels":[],"product":"prod_RXcftEi6BIxozY","plan":"price_1SXbeBJg0YSXb5HsjV5Lk2Ji"}',
        increaseTime: 1764146646176,
        modelCode: '1',
        originalPrice: 11800,
        realPrice: 11800,
        sort: 9889,
        title: 'AI积分-118',
      },
      {
        commodityCode: '1776673264119365632',
        commodityType: 10,
        content: {
          commodityName: 'single_cloud_right',
          currency: 'USD',
          durationType: 5,
          mainRightId: 4647,
          point: 2000,
          sonRightIds: [4647],
        },
        desc: '2000积分',
        discount: 1.0,
        extend:
          '{"showPrice":0,"isHiddenSku":false,"deviceModels":"","mainRightId":4647,"sonRightIds":[4647],"restrictedPaymentChannels":[],"product":"prod_RXcftEi6BIxozY","plan":"price_1SXbeMJg0YSXb5HsrkcZBOux"}',
        increaseTime: 1764146646608,
        modelCode: '1',
        originalPrice: 19800,
        realPrice: 19800,
        sort: 9890,
        title: 'AI积分包-198',
      },
    ],
    enterpriseVip: [
      {
        funcName: 'subtitleTranslate',
        funcTitle: '字幕翻译',
      },
      {
        funcName: 'audioTranslate',
        funcTitle: '旁白翻译',
      },
      {
        funcName: 'digitalHumanVideo',
        funcTitle: '数字人视频',
      },
      {
        funcName: 'textEdit',
        funcTitle: '字体编辑',
      },
      {
        funcName: 'videoFaceMerge',
        funcTitle: '视频换脸',
      },
      {
        funcName: 'lipSync',
        funcTitle: '口型对齐语音',
      },
      {
        funcName: 'removeWaterMark',
        funcTitle: '去水印',
      },
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'exportResolution',
        funcTitle: '导出视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'duration',
        funcTitle: '上传视频时长',
        functionLimit: 100000000,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 4,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 100,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 100,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'subtitleRemove',
        funcTitle: '字幕擦除',
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量（单位M）',
        functionLimit: 1024000,
      },
      {
        funcName: 'voiceChanging',
        funcTitle: 'AI变声',
      },
      {
        funcName: 'textToSpeech',
        funcTitle: '文本生成TTS',
      },
      {
        funcName: 'embeddedWorkflow',
        funcTitle: '预制工作流',
      },
      {
        funcName: 'customWorkflow',
        funcTitle: '自定义工作流',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
    ],
    freeVip: [
      {
        funcName: 'subtitleTranslate',
        funcTitle: '字幕翻译',
      },
      {
        funcName: 'digitalHumanVideo',
        funcTitle: '数字人视频',
      },
      {
        funcName: 'subtitleRemove',
        funcTitle: '字幕擦除',
      },
      {
        funcName: 'uploadResolution',
        funcTitle: '上传视频分辨率',
        functionLimit: 2160,
      },
      {
        funcName: 'exportResolution',
        funcTitle: '导出视频分辨率',
        functionLimit: 720,
      },
      {
        funcName: 'duration',
        funcTitle: '上传视频时长',
        functionLimit: 10,
      },
      {
        funcName: 'batchNum',
        funcTitle: '批量任务数',
        functionLimit: 10,
      },
      {
        funcName: 'weight',
        funcTitle: '权重',
        functionLimit: 1,
      },
      {
        funcName: 'voiceCloneNum',
        funcTitle: '音色克隆席位',
        functionLimit: 1,
      },
      {
        funcName: 'digitalHumanNum',
        funcTitle: '定制数字人席位',
        functionLimit: 2,
      },
      {
        funcName: 'assetAvailablePeriod',
        funcTitle: '作品有效期',
        functionLimit: 100000000,
      },
      {
        funcName: 'cloudStorageCapacityMB',
        funcTitle: '云盘存储容量（单位M）',
        functionLimit: 1024000,
      },
      {
        funcName: 'videoFaceMerge',
        funcTitle: '视频换脸',
      },
      {
        funcName: 'voiceChanging',
        funcTitle: 'AI变声',
      },
      {
        funcName: 'textToSpeech',
        funcTitle: '文本生成TTS',
      },
      {
        funcName: 'embeddedWorkflow',
        funcTitle: '预制工作流',
      },
      {
        funcName: 'customWorkflow',
        funcTitle: '自定义工作流',
      },
      {
        funcName: 'fVoiceClone',
        funcTitle: '3.0音色克隆',
      },
      {
        funcName: 'fimageGenerate',
        funcTitle: '3.0生成图片',
      },
      {
        funcName: 'fVideoGenerate',
        funcTitle: '3.0生成视频',
      },
      {
        funcName: 'fProductAvatar',
        funcTitle: '3.0产品数字人',
      },
      {
        funcName: 'fLipSyncV2',
        funcTitle: '3.0数字人视频2.0',
      },
      {
        funcName: 'fAudioTranslate',
        funcTitle: '3.0旁白翻译',
      },
      {
        funcName: 'fSubtitleTranslate',
        funcTitle: '3.0字幕翻译',
      },
      {
        funcName: 'fHeadSwap',
        funcTitle: '3.0视频换头',
      },
      {
        funcName: 'fTextToSpeech',
        funcTitle: '3.0文本转语音',
      },
    ],
  },
  message: 'successful',
  success: true,
};
